import React from "react";
import { CiBellOn, CiShare2 } from "react-icons/ci";
import CustomDrawer from "../Components/CustomDrawer/CustomDrawer";
import { useNavigate } from "react-router-dom";
import { Image, Spacer } from "@nextui-org/react";
import MobileBanner from "./Banner/MobileBanner";
import SearchIcon from "../assets/images/Search.png";
import { Col } from "antd";
import { Trans, useTranslation } from "react-i18next";
import OptimizedImage from "./OptimizedImage";

const Header = ({
  image,
  name,
  userName,
  onBellClick,
  onShareClick,
  notification_bell,
  endContent,
  showIcons = true,
  textSize = 24,
  showMenu = false,
  isAffiliate = false,
  isDashboard = false,
  setOpenSheet,
  startContent,
  location,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!name || !userName) return null;
  return (
    <div className="flex flex-col ">
      <div className="flex flex-row pt-4 pb-3 items-center">
        {showMenu === true && <CustomDrawer />}

        <OptimizedImage
          Header={true}
          src={image}
          alt={""}
          className="h-10 w-10 object-cover mr-2 ml-2 flex-shrink-0 rounded-full"
          loading="lazy"
          priority={true}
        />
        <div
          className="flex flex-col justify-between cursor-pointer ml-1 mr-2 flex-1 min-w-0"
          onClick={() => navigate("/about")}
        >
          <p className="text-[21px] font-medium text-ink-900 tracking-[-0.015em] truncate whitespace-nowrap overflow-hidden">
            {name}
          </p>

          <p className="text-[12.5px] text-ink-500 truncate whitespace-nowrap overflow-hidden">
            <Trans
              i18nKey="dashboardHeader.storeBy"
              values={{ name: userName }}
              components={[<span className="text-[12.5px] capitalize pl-0" />]}
            />
            {location && (
              <span className="text-[12.5px] capitalize">{`, ${location}`}</span>
            )}
          </p>
        </div>
        <div className="ml-auto flex flex-row space-x-3 flex-shrink-0">
          {startContent && <div>{startContent}</div>}
          {showIcons === true && !endContent && (
            <>
              {!endContent && notification_bell && (
                <div className="w-10 h-10 rounded-lg border-2 border-gray-300 flex justify-center items-center cursor-pointer">
                  <CiBellOn className="h-6 w-6" onClick={onBellClick} />
                </div>
              )}

              <div className="w-10 h-10 rounded-lg border-2 border-gray-300 flex justify-center items-center cursor-pointer">
                <CiShare2
                  className="h-6 w-6 font-medium"
                  onClick={onShareClick}
                />
              </div>
            </>
          )}
          {endContent && (
            <div className="w-[38px] h-[38px] rounded-[10px] bg-wc-gray flex justify-center items-center cursor-pointer">
              {endContent}
            </div>
          )}
        </div>
      </div>
      {isDashboard && (
        // <div>
        //   <div className="flex flex-row pb-2 justify-center items-center w-full">
        //     <div className="pr-1">
        //       <img
        //         src={freeDeliveryIcon}
        //         alt="free delivery"
        //         className="w-8 h-8 pr-0"
        //       />
        //     </div>
        //     <p className="text-sm font-light">
        //       <span className="text-sm font-light capitalize pl-1">
        //         {"Free shipping on pre-paid orders over ₹499"}
        //       </span>
        //     </p>
        //   </div>
        // </div>
        <>
          <MobileBanner setOpenSheet={setOpenSheet} />
          <div className="bg-bgColor px-2">
            <Col span={24}>
              <div
                className="flex bg-white rounded-lg px-2 py-4 cursor-pointer"
                onClick={() => navigate("/search")}
              >
                <Image
                  width={"100%"}
                  src={SearchIcon}
                  alt="NextUI Album Cover"
                />
                <p className="ml-3 text-base font-light text-[#668091]">
                  {t("dashboardHeader.searchPlaceholder")}
                </p>
              </div>

              <Spacer y={4} />
            </Col>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
